export default __webpack_public_path__ + "static/media/1.90dcaa71.png";